import { type JSX, useCallback } from 'react'

import { AnalyticsQueryColumn, AnalyticsQueryFilter } from '@hap/analytics'

import { FILTER_CONTROL_FIELDS } from './constants'
import { Filter, FilterContent, FilterTrigger, NewFilterTrigger } from './filter'
import { useFilterAccess } from './use-filter-access'

export function FilterControl(props: Props): JSX.Element {
  const { isFilterAllowed } = useFilterAccess()
  const selectableFields = props.selectableFilters || FILTER_CONTROL_FIELDS
  const canAddFilter = selectableFields.some(isFilterAllowed)
  const handleChange = (index: number, updates: AnalyticsQueryFilter) => {
    props.onSubmit(props.filters.toSpliced(index, 1, updates))
  }

  const handleRemove = useCallback(
    (index: number) => {
      props.onSubmit(props.filters.toSpliced(index, 1))
    },
    [props],
  )

  return (
    <div className="flex h-full flex-wrap items-center gap-2">
      {[...props.filters, ...(canAddFilter ? [undefined] : [])].map((filter, index) => {
        const readOnly = !!filter && !isFilterAllowed(filter.field)
        return (
          <Filter
            selectableFilters={props.selectableFilters}
            filter={filter}
            key={index}
            onSelect={(updates) => handleChange(index, updates)}
            contextFilters={props.contextFilters}
          >
            {filter ? (
              <FilterTrigger readOnly={readOnly} onDelete={() => handleRemove(index)} />
            ) : (
              <NewFilterTrigger condensed={props.filters.length > 0} />
            )}
            <FilterContent />
          </Filter>
        )
      })}
    </div>
  )
}

interface Props {
  filters: AnalyticsQueryFilter[]
  onSubmit: (filters: AnalyticsQueryFilter[]) => void
  selectableFilters?: AnalyticsQueryColumn[]
  contextFilters?: {
    [key: string]: {
      $eq: string[]
    }
  }
}
